<template>
  <div class="pdf-full-layout final-preview-panel">
    <!-- 고정 페이지들 (앞) -->
    <div v-if="isFixedPageEnabled('cover')" :style="getPdfPageStyle()">
      <div :style="getFixedPageInnerStyle()">
        <article-cover-page
          :group="{}"
          :journal="journal"
          :page-size="journal?.page_size || pageSize"
        />
      </div>
    </div>

    <div v-if="isFixedPageEnabled('inner_front')" :style="getPdfPageStyle()">
      <div :style="getFixedPageInnerStyle()">
        <article-inner-cover-front
          :group="{}"
          :journal="journal"
          :page-size="journal?.page_size || pageSize"
        />
      </div>
    </div>

    <div v-if="isFixedPageEnabled('info')" :style="getPdfPageStyle()">
      <div :style="getFixedPageInnerStyle()">
        <article-info-page
          :item="{}"
          :group="{}"
          :journal="journal"
          :page-size="journal?.page_size || pageSize"
        />
      </div>
      <!-- <div
        v-if="getFixedPageNumber('info') % 2 !== 0"
        class="page-footer page-footer-odd"
        :style="getPdfFooterStyle(getFixedPageNumber('info'))"
      >
        <span class="page-number">{{ getFixedPageNumber('info') }}</span>
      </div>
      <div v-else class="page-footer page-footer-even" :style="getPdfFooterStyle(getFixedPageNumber('info'))">
        <span class="page-number">{{ getFixedPageNumber('info') }}</span>
      </div> -->
    </div>

    <div v-if="isFixedPageEnabled('title')" :style="getPdfPageStyle()">
      <div :style="getFixedPageInnerStyle()">
        <article-title-page
          :group="{}"
          :journal="journal"
          :page-size="journal?.page_size || pageSize"
        />
      </div>
      <!-- <div
        v-if="getFixedPageNumber('title') % 2 !== 0"
        class="page-footer page-footer-odd"
        :style="getPdfFooterStyle(getFixedPageNumber('title'))"
      >
        <span class="page-number">{{ getFixedPageNumber('title') }}</span>
      </div>
      <div v-else class="page-footer page-footer-even" :style="getPdfFooterStyle(getFixedPageNumber('title'))">
        <span class="page-number">{{ getFixedPageNumber('title') }}</span>
      </div> -->
    </div>

    <div v-if="isFixedPageEnabled('toc')" :style="getPdfPageStyle()">
      <div :style="getFixedPageInnerStyle()">
        <article-table-of-contents
          :group="{}"
          :journal="journal"
          :items="items"
          :page-size="journal?.page_size || pageSize"
        />
      </div>
      <!-- <div
        v-if="getFixedPageNumber('toc') % 2 !== 0"
        class="page-footer page-footer-odd"
        :style="getPdfFooterStyle(getFixedPageNumber('toc'))"
      >
        <span class="page-number">{{ getFixedPageNumber('toc') }}</span>
      </div>
      <div v-else class="page-footer page-footer-even" :style="getPdfFooterStyle(getFixedPageNumber('toc'))">
        <span class="page-number">{{ getFixedPageNumber('toc') }}</span>
      </div> -->
    </div>

    <div v-if="isFixedPageEnabled('blank')" :style="getPdfPageStyle()">
      <div :style="getFixedPageInnerStyle()">
        <article-blank-page
          :group="{}"
          :journal="journal"
          :page-size="journal?.page_size || pageSize"
        />
      </div>
      <!-- <div
        v-if="getFixedPageNumber('blank') % 2 !== 0"
        class="page-footer page-footer-odd"
        :style="getPdfFooterStyle(getFixedPageNumber('blank'))"
      >
        <span class="page-number">{{ getFixedPageNumber('blank') }}</span>
      </div>
      <div v-else class="page-footer page-footer-even" :style="getPdfFooterStyle(getFixedPageNumber('blank'))">
        <span class="page-number">{{ getFixedPageNumber('blank') }}</span>
      </div> -->
    </div>

    <!-- 논문 데이터 및 공페이지들 -->
    <div
      v-for="page in pages"
      :key="page.key"
      class="paper-page"
      :style="getPdfPageStyle()"
    >
      <template v-if="page.type === 'blank'">
        <div class="page-inner" :style="getPdfPageInnerStyle(page.pageNumber)"></div>
      </template>

      <template v-else-if="page.type === 'paper-cover'">
        <div class="page-inner" :style="getPdfPageInnerStyle(page.pageNumber)">
          <div class="cover-title-area">
            <h1 class="cover-main-title">
              {{ page.paper.title }}<span v-if="page.paper.subtitle">: {{ page.paper.subtitle }}</span
              ><span v-if="pageHasTitlePageComment(page.paper)">*</span>
            </h1>
            <h2 v-if="page.paper.title_eng" class="cover-sub-title">{{ page.paper.title_eng }}</h2>
          </div>
          <div class="cover-divider"></div>
          <div class="cover-authors-area">
            <span
              v-for="(author, idx) in page.paper.authors"
              :key="`full-pdf-cover-${page.paper.idx}-${idx}`"
              class="author-item"
            >
              <span class="author-name">{{ author.full_name }}</span>
              <span v-if="author.name_eng" class="author-name-eng">{{ author.name_eng }}</span>
              <span v-if="author.organization" class="author-org">({{ author.organization }})</span>
              <span v-if="author.organization_eng" class="author-org-eng">{{ author.organization_eng }}</span>
              <span v-if="idx < page.paper.authors.length - 1">, </span>
            </span>
          </div>
        </div>
        <div
          v-if="page.comments && page.comments.length > 0"
          class="page-comments-bottom"
          :style="getPdfCommentsStyle(page.pageNumber)"
        >
          <div class="comments-divider"></div>
          <div
            v-for="comment in page.comments"
            :key="comment.idx"
            class="page-comment"
          >
            <sup>{{ comment.superscript }}</sup> {{ comment.content }}
          </div>
        </div>
      </template>

      <template v-else-if="page.type === 'abstract'">
        <div class="page-inner" :style="getPdfPageInnerStyle(page.pageNumber)">
          <h3 v-if="page.isFirst" class="abstract-title">● 초록(Abstract)</h3>
          <div class="abstract-content" v-html="page.html"></div>
          <div
            v-if="page.isLast && (page.paper.keyword || page.paper.keyword_eng)"
            class="keyword-area"
          >
            <span class="keyword-label">핵심어</span>
            <span class="keyword-text">{{ page.paper.keyword || page.paper.keyword_eng }}</span>
          </div>
        </div>
        <div
          v-if="page.pageNumber % 2 !== 0"
          class="page-footer page-footer-odd"
          :style="getPdfFooterStyle(page.pageNumber)"
        >
          <span class="page-number">{{ page.pageNumber }}</span>
          <span class="footer-text">{{ page.group?.title || '' }}</span>
        </div>
        <div v-else class="page-footer page-footer-even" :style="getPdfFooterStyle(page.pageNumber)">
          <span class="footer-text">{{ page.paper?.title || '' }}</span>
          <span class="page-number">{{ page.pageNumber }}</span>
        </div>
      </template>

      <template v-else>
        <div class="page-inner" :style="getPdfPageInnerStyle(page.pageNumber)">
          <div class="paper-content" v-html="page.html"></div>
        </div>
        <div
          v-if="page.comments.length > 0"
          class="page-comments-bottom"
          :style="getPdfCommentsStyle(page.pageNumber)"
        >
          <div class="comments-divider"></div>
          <div
            v-for="comment in page.comments"
            :key="comment.idx"
            class="page-comment"
          >
            <sup>{{ comment.superscript }}</sup> {{ comment.content }}
          </div>
        </div>
        <div
          v-if="page.pageNumber % 2 !== 0"
          class="page-footer page-footer-odd"
          :style="getPdfFooterStyle(page.pageNumber)"
        >
          <span class="page-number">{{ page.pageNumber }}</span>
          <span class="footer-text">{{ page.group?.title || '' }}</span>
        </div>
        <div v-else class="page-footer page-footer-even" :style="getPdfFooterStyle(page.pageNumber)">
          <span class="footer-text">{{ page.paper?.title || '' }}</span>
          <span class="page-number">{{ page.pageNumber }}</span>
        </div>
      </template>
    </div>

    <!-- 고정 페이지들 (뒤) -->
    <div v-if="isFixedPageEnabled('inner_back')" :style="getPdfPageStyle()">
      <div :style="getFixedPageInnerStyle()">
        <article-inner-cover-back
          :group="{}"
          :journal="journal"
          :page-size="journal?.page_size || pageSize"
        />
      </div>
    </div>

    <div v-if="isFixedPageEnabled('backcover')" :style="getPdfPageStyle()">
      <div :style="getFixedPageInnerStyle()">
        <article-committee-page
          :group="{}"
          :journal="journal"
          :items="items"
          :page-size="journal?.page_size || pageSize"
        />
      </div>
    </div>
  </div>
</template>

<script>
// 임도트 components
import ArticleCoverPage from "@/components/Templates/article/ArticleCoverPage.vue";
import ArticleInnerCoverFront from "@/components/Templates/article/ArticleInnerCoverFront.vue";
import ArticleInfoPage from "@/components/Templates/article/ArticleInfoPage.vue";
import ArticleTitlePage from "@/components/Templates/article/ArticleTitlePage.vue";
import ArticleTableOfContents from "@/components/Templates/article/ArticleTableOfContents.vue";
import ArticleBlankPage from "@/components/Templates/article/ArticleBlankPage.vue";
import ArticleInnerCoverBack from "@/components/Templates/article/ArticleInnerCoverBack.vue";
import ArticleCommitteePage from "@/components/Templates/article/ArticleCommitteePage.vue";

import { PAGE_DIMENSIONS, getPagePadding } from "@/utils/paperEditor";

export default {
  name: "FullJournalPreviewContent",
  components: {
    ArticleCoverPage,
    ArticleInnerCoverFront,
    ArticleInfoPage,
    ArticleTitlePage,
    ArticleTableOfContents,
    ArticleBlankPage,
    ArticleInnerCoverBack,
    ArticleCommitteePage,
  },
  props: {
    journal: {
      type: Object,
      required: true,
    },
    pageSize: {
      type: String,
      default: "A4",
    },
    scale: {
      type: Number,
      default: 1,
    },
    pages: {
      type: Array,
      required: true,
    },
    items: {
      type: Array,
      required: true,
    },
    // 고정 페이지 활성화 여부를 판단하는 함수 또는 미리 계산된 맵을 받습니다.
    enabledFixedPages: {
      type: [Object, Function],
      default: () => ({}),
    },
  },
  computed: {
    dimensions() {
      return PAGE_DIMENSIONS[this.pageSize] || PAGE_DIMENSIONS["A4"];
    },
  },
  methods: {
    isFixedPageEnabled(pageId) {
      if (typeof this.enabledFixedPages === "function") {
        return this.enabledFixedPages(pageId);
      }
      return this.enabledFixedPages[pageId] !== false;
    },
    getFixedPageNumber(pageId) {
      const frontOrder = ["cover", "inner_front", "info", "title", "toc", "blank"];
      let num = 0;
      for (const id of frontOrder) {
        if (this.isFixedPageEnabled(id)) {
          num++;
          if (id === pageId) return num;
        }
      }

      // 논문 페이지들 이후
      const backOrder = ["inner_back", "backcover"];
      const frontCount = frontOrder.filter((id) => this.isFixedPageEnabled(id)).length;
      let totalBeforeBack = frontCount + this.pages.length;
      num = totalBeforeBack;
      for (const id of backOrder) {
        if (this.isFixedPageEnabled(id)) {
          num++;
          if (id === pageId) return num;
        }
      }
      return num;
    },
    getPdfPageStyle() {
      return {
        width: `${this.dimensions.width * this.scale}px`,
        height: `${this.dimensions.height * this.scale}px`,
        backgroundColor: "white",
        position: "relative",
        overflow: "hidden",
        pageBreakAfter: "always",
        margin: `0 auto ${20 * this.scale}px`,
      };
    },
    getFixedPageInnerStyle() {
      return {
        width: `${this.dimensions.width}px`,
        height: `${this.dimensions.height}px`,
        transform: `scale(${this.scale})`,
        transformOrigin: "top left",
      };
    },
    getPdfPageInnerStyle(pageNumber) {
      const { paddingLeft, paddingRight } = getPagePadding(this.pageSize, pageNumber);
      return {
        width: `${this.dimensions.width}px`,
        height: `${this.dimensions.height}px`,
        padding: `${this.dimensions.verticalPadding}px ${paddingRight}px ${this.dimensions.verticalPadding}px ${paddingLeft}px`,
        boxSizing: "border-box",
        fontFamily: '"KoPubWorldBatang", "Noto Serif KR", serif',
        fontSize: "10.5pt",
        lineHeight: "1.6",
        position: "relative",
        transform: `scale(${this.scale})`,
        transformOrigin: "top left",
      };
    },
    getPdfFooterStyle(pageNumber) {
      const { paddingLeft, paddingRight } = getPagePadding(this.pageSize, pageNumber);
      const footerBottom = this.dimensions.footerBottom || 30;
      return {
        left: `${paddingLeft * this.scale}px`,
        right: `${paddingRight * this.scale}px`,
        bottom: `${footerBottom * this.scale}px`,
      };
    },
    getPdfCommentsStyle(pageNumber) {
      const { paddingLeft, paddingRight } = getPagePadding(this.pageSize, pageNumber);
      const bottom = 55;
      return {
        left: `${paddingLeft * this.scale}px`,
        right: `${paddingRight * this.scale}px`,
        bottom: `${bottom * this.scale}px`,
      };
    },
    pageHasTitlePageComment(paper) {
      return (paper?.comments || []).some((comment) =>
        this.isTitlePageComment(comment)
      );
    },
    isTitlePageComment(comment) {
      if (!comment) return false;
      if (comment.page === "title_page") return true;
      return comment.superscript === "*" && Number(comment.page) === 1;
    },
  },
};
</script>

<style scoped>
/* 여기에 필요한 경우 추가적인 로컬 스타일을 정의합니다. */
/* 대부분의 스타일은 paper-preview.css에 정의되어 있습니다. */
</style>
